<script>
import { commonInputProps, fieldWrapperProps } from '../../../helpers/input'

export default {
    name: 'Field',

    props: {
        ...commonInputProps,
        ...fieldWrapperProps,

        inputClasses: String,

        value: {
            default: null,
        },

        autoCleanErrors: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        getInputClasses() {
            let classes = this.inputClasses ? this.inputClasses.split(' ') : []
            if (this.error) classes.push('input-danger')
            return classes
        },

        eventListeners() {
            return { ...this.$listeners, input: this.onInput }
        },
    },

    methods: {
        getInput() {
            return this.$refs.inputFieldRef.$el || this.$refs.inputFieldRef
        },

        focus() {
            this.getInput().focus()
        },

        blur() {
            this.getInput().blur()
        },

        selectText() {
            this.getInput().setSelectionRange(
                0,
                (this.getInput().value || '').length
            )
        },
    },
}
</script>
